import { render } from "./DatePickerWrap.vue?vue&type=template&id=fa486d44"
import script from "./DatePickerWrap.vue?vue&type=script&lang=js"
export * from "./DatePickerWrap.vue?vue&type=script&lang=js"

import "./DatePickerWrap.vue?vue&type=style&index=0&id=fa486d44&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__